import { useMemo } from 'react';

const DROP_OF_VERIFICATION = {
  leaveAtDoor: 'Leave it at my door.',
  meetAtDoor: 'Hand it to me.'
}

const useDeliveryInfo = (
  deliveryInfo, 
  orderUUid,
  businessId, 
  businessUuid
) => {

  const dropOffVerification = useMemo(() => {
    return deliveryInfo?.leaveAtDoor ?
      DROP_OF_VERIFICATION.leaveAtDoor :
      deliveryInfo?.meetAtDoor ? DROP_OF_VERIFICATION.meetAtDoor : ''
  }, [deliveryInfo?.leaveAtDoor, deliveryInfo?.meetAtDoor])

  const deliveryBy = useMemo(() => {
    if ((deliveryInfo?.delivery?.provider === 'self') || 
    (deliveryInfo?.quote?.provider === 'self')) {
      return 'IN-HOUSE DELIVERY'
    }
    if ((deliveryInfo?.delivery?.provider === 'dispatch') || 
    (deliveryInfo?.quote?.provider === 'dispatch')) {
      return 'AI DISPATCH'
    }
    if (deliveryInfo?.delivery?.provider || deliveryInfo?.quote?.provider) {
      return deliveryInfo?.delivery?.provider?.toUpperCase() ||
       deliveryInfo?.quote?.provider?.toUpperCase();
    }
    return null
  }, [deliveryInfo?.quote?.provider, deliveryInfo?.delivery?.provider])


  const fullAddress = deliveryInfo?.addressInfo?.fullAddress;
  const addressParts = fullAddress.split(',');
  // Remove trailing comma and whitespace from each part
  const cleanParts = addressParts.map(part => part.trim());

  // Check if second to last part contains zip code (5 digits)
  const hasZipCode = /\d{5}/.test(cleanParts[cleanParts.length - 2]);

  // If zip code found, remove last part and join
  const address = hasZipCode ?
    cleanParts.slice(0, -1).join(', ') :
    fullAddress;

  // Detect mobile platform and use appropriate maps URL
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const isAndroid = /Android/i.test(navigator.userAgent);

  let mapsUrl;
  if (isMobile) {
    if (isIOS) {
      mapsUrl = `maps://?q=${encodeURIComponent(address)}`;
    } else if (isAndroid) {
      mapsUrl = `geo:0,0?q=${encodeURIComponent(address)}`;
    } else {
      mapsUrl = `https://maps.google.com/maps?q=${encodeURIComponent(address)}`;
    }
  } else if (isIOS) {
    mapsUrl = `http://maps.apple.com/?q=${encodeURIComponent(address)}`;
  } else {
    mapsUrl = `https://maps.google.com/maps?q=${encodeURIComponent(address)}`;
  }

  const generateTracingUrl = useMemo(() => {
    return `${process.env.REACT_APP_TRACK_URL}?oUuid=${orderUUid}&bid=${businessId}&bUuid=${businessUuid}`
  }, [orderUUid, businessId, businessUuid ])

  return {
    deliveryInfo,
    deliveryBy,
    address,
    generateTracingUrl,
    dropOffVerification,
  }
};

export default useDeliveryInfo;